<template>
    <div :class="$style.app">
        <router-view></router-view>

        <div :class="$style.modal" @click="$store.commit('data/RESET_TICKET')" v-if="ticket">
            <div :class="[$style.content, $style.ticket]" @click="event => event.stopPropagation()">
                <h1 :class="$style.headline">
                    {{ $t("headlines.personal_code") }}
                    <span>{{ ticket.password }}</span>
                </h1>
                <h2 :class="$style.title">{{ $t("headlines.send_code_to_email") }}</h2>
                <h3 :class="$style.text">{{ $t("headlines.thanks_purchase") }}!</h3>
            </div>
        </div>

        <ModalCheckingTicket v-if="fetching" />
    </div>
</template>

<script>
import ModalCheckingTicket from "./ModalCheckingTicket";
import { mapState } from "vuex";

export default {
    name: "App",

    components: { ModalCheckingTicket },

    computed: {
        ...mapState("data", ["data", "ticket"]),
        ...mapState("ticket", ["fetching"]),
    },
};
</script>

<style module>
.app {
    width: 100%;
    min-height: 100vh;
}

.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.56);
    display: flex;
    align-items: center;
    justify-content: center;
}

.content {
    background: rgb(255, 255, 255);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);
    padding: 24px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.price > .headline {
    font-size: 32px;
    font-weight: 400;
    text-align: center;
}

.price > .headline > span {
    background-color: #eee;
    padding: 12px 24px;
    border-radius: 4px;
    display: inline-block;
    margin: 0 12px;
    color: #0051ff;
}

.price > .title {
    color: rgba(0, 0, 0, 0.87);
    font-size: 24px;
    margin: 18px 0 0 0;
    font-weight: 400;
}

.ticket > .headline {
    font-size: 32px;
    font-weight: 400;
    text-align: center;
}

.ticket > .headline > span {
    background-color: #eee;
    padding: 12px 24px;
    border-radius: 4px;
    display: inline-block;
    margin-left: 12px;
    color: #0051ff;
}

.title {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
}

.ticket > .text {
    font-size: 18px;
    font-weight: 400;
    text-align: center;
}

.actions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    padding-top: 24px;
}

.button {
    border: none;
    min-width: 88px;
    font-family: inherit;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    padding: 0 16px;
    border-radius: 4px;
    cursor: pointer;
}

.close {
    background-color: #eee;
    color: rgba(0, 0, 0, 0.87);
}

.continue {
    background-color: rgb(65, 65, 255);
    color: rgb(255, 255, 255);
}

.continue:not(:disabled) {
    cursor: pointer;
    background-color: rgb(65, 65, 255);
    color: rgb(255, 255, 255);
}

.continue:disabled {
    background-color: #eee;
}

.continue:disabled > div {
    border: 2px solid rgb(185, 185, 185);
    border-radius: 50%;
    border-top: 2px solid rgb(65, 65, 255);
    width: 18px;
    height: 18px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
